import {
    SERVICE_EMAIL_CONFIRMATION,
    SERVICE_EMAIL_CONFIRMATION_SUCCESS,
    SERVICE_EMAIL_CONFIRMATION_FAIL
  } from "./actionTypes";
  
  const INIT_STATE = {
    confirmation_status: '',
  };
  
  const ServiceEmailConfirmation = (state = INIT_STATE, action) => {
    switch (action.type) {
      case SERVICE_EMAIL_CONFIRMATION:
        return {
          ...state,
          error: action.payload,
        }
  
      case SERVICE_EMAIL_CONFIRMATION_SUCCESS:
        return {
          ...state,
          confirmation_status: action.payload,
        }
  
      case SERVICE_EMAIL_CONFIRMATION_FAIL:
        return {
          ...state,
          confirmation_status: action.payload,
        }
  
      default:
        return state
    }
  }
  
  export default ServiceEmailConfirmation;
